module.exports = __webpack_public_path__ + "static/media/portadasms.e4b0ad36.jpg";